import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { includes } from 'ramda';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ShowOnlyOnPrint } from 'components';
import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { TASK_TYPES } from 'features/views/taskDetail/constants';
import { getDetail } from 'features/views/taskDetail/selectors';
import { getStringOrOneOf } from 'features/views/taskDetail/utils';
import { equalOrThreeDashes } from 'utils';
import { getClientName } from 'utils/client';

const { LOSE_COMISSION, REQUEST_FOR_SELLER_CP } = TASK_TYPES;

const ClientInfoPrintOnly = () => {
	const taskDetail = useSelector(getDetail);

	const { taskTypeId, metadata = {}, client = {} } = taskDetail;
	const { address } = client;
	const { common = {} } = metadata;

	const fullStreet = address && getStringOrOneOf(address?.street, address?.streetNo);
	const name = getClientName(client);
	const phoneValue = includes(taskTypeId, [LOSE_COMISSION])
		? equalOrThreeDashes(common.clientCellPhone || common.clientPhone)
		: equalOrThreeDashes(client.phone);

	const emailValue = includes(taskTypeId, [LOSE_COMISSION])
		? equalOrThreeDashes(common.clientEmail)
		: equalOrThreeDashes(client.email);

	return (
		<ShowOnlyOnPrint>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('taskDetailPrint:clientInfoHeader')} />
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={2}>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="fullName"
										label={getLabelMessage('taskDetailPrint:fullName')}
										fullWidth
										value={equalOrThreeDashes(name)}
										slotProps={{
											inputLabel: {
												shrink: !!equalOrThreeDashes(name),
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="businessIn"
										label={getLabelMessage('taskDetailPrint:businessIn')}
										fullWidth
										value={equalOrThreeDashes(client.businessIn)}
										slotProps={{
											inputLabel: {
												shrink: !!equalOrThreeDashes(client.businessIn),
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="city"
										label={getLabelMessage('taskDetailPrint:city')}
										fullWidth
										value={equalOrThreeDashes(address?.municipality)}
										slotProps={{
											inputLabel: {
												shrink: !!equalOrThreeDashes(address?.municipality),
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="street"
										label={getLabelMessage('taskDetailPrint:street')}
										fullWidth
										value={equalOrThreeDashes(fullStreet)}
										slotProps={{
											inputLabel: {
												shrink: !!equalOrThreeDashes(fullStreet),
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="PSC"
										label={getLabelMessage('taskDetailPrint:PSC')}
										fullWidth
										value={equalOrThreeDashes(address?.zipCode)}
										slotProps={{
											inputLabel: {
												shrink: !!equalOrThreeDashes(address?.zipCode),
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="phone"
										label={getLabelMessage('taskDetailPrint:phone')}
										fullWidth
										value={phoneValue}
										slotProps={{
											inputLabel: {
												shrink: !!phoneValue,
											},
										}}
									/>
								</Grid>
								<Grid size={6}>
									<OutputTextField
										size="small"
										id="email"
										label={getLabelMessage('taskDetailPrint:email')}
										fullWidth
										value={emailValue}
										slotProps={{
											inputLabel: {
												shrink: !!emailValue,
											},
										}}
									/>
								</Grid>

								{includes(taskTypeId, [REQUEST_FOR_SELLER_CP]) && (
									<Grid size={6}>
										<OutputTextField
											size="small"
											id="phoneKC"
											label={getLabelMessage('taskDetailPrint:phoneKC')}
											fullWidth
											value={equalOrThreeDashes(common.phone)}
											slotProps={{
												inputLabel: {
													shrink: !!equalOrThreeDashes(common.phone),
												},
											}}
										/>
									</Grid>
								)}

								{includes(taskTypeId, [REQUEST_FOR_SELLER_CP]) && (
									<Grid size={6}>
										<OutputTextField
											size="small"
											id="emailKC"
											label={getLabelMessage('taskDetailPrint:emailKC')}
											fullWidth
											value={equalOrThreeDashes(common.email)}
											slotProps={{
												inputLabel: {
													shrink: !!equalOrThreeDashes(common.email),
												},
											}}
										/>
									</Grid>
								)}

								{includes(taskTypeId, [49, 50, 51, 52]) && (
									<Grid size={6}>
										<OutputTextField
											size="small"
											id="phoneMaintenance"
											label={getLabelMessage('taskDetailPrint:phoneMaintenance')}
											fullWidth
											value={equalOrThreeDashes(common.phone)}
											slotProps={{
												inputLabel: {
													shrink: !!equalOrThreeDashes(common.phone),
												},
											}}
										/>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Grid>
				</Stack>
			</Paper>
		</ShowOnlyOnPrint>
	);
};

export default ClientInfoPrintOnly;
